module.exports = {"getError":"Error loading groups","addButton":"+ add new group","newGroupName":"New group"}